<template>
  <div class="card-wrapper products">
    <a class="answer-card product-card" :href="option.product_url" :target="option.product_url !== '#' ? '_blank' : '_self'">

      <div class="product-card-header">
        <div class="label" v-text="option.label"></div>
        <div class="article-number" v-if="option.sku">{{ $t('result.article_number') }}: {{option.sku}}</div>
      </div>

      <div class="card-image">
        <img :src="option.image_url" alt="">
      </div>

      <div class="delivery-time" v-if="option.delivery_time">
        <img class="icon" :src="publicImage('themes/elektramat/check-circle-success.svg')" alt="Checkmark"/>
        {{ $t('result.delivery_time') }} <strong>{{option.delivery_time }} {{ $tc('result.workday', option.delivery_time) }}
      </strong>
      </div>


      <div class="price-btn-container" v-if="!option.noResult" :class="{ 'has-delivery-time': option.delivery_time }">
        <div class="prices" v-if="option.price">
          <div class="previous-price" v-if="option.priceBefore">
            {{ $store.state.includingVat ? getBtwPrice(option.priceBefore) : formatPrice(option.priceBefore) }}
          </div>
          <div class="current-price">
            {{ $store.state.includingVat ? getBtwPrice(option.price) : formatPrice(option.price) }}
            <span class="quantity">{{ $t('result.per_unit') }}</span>
          </div>
          <div class="current-price with-tax">
            <template v-if="$store.state.includingVat">
              {{ formatPrice(option.price) }}
              <span class="tax">{{ $t('result.excluding_tax') }}</span>
            </template>
            <template v-else>
              {{ getBtwPrice(option.price) }}
              <span class="tax">{{ $t('result.including_tax') }}</span>
            </template>
          </div>
        </div>
        <a
          v-if="!option.noResult && option.product_url"
          :href="option.product_url"
          target="_blank"
          class="btn success">{{ option.url_text }}</a>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "CardProduct",

  props: {
    option: {
      type: Object,
      required: true,
    }
  },

  methods: {
    formatPrice(price) {
      return parseFloat(price)
        .toFixed(2)
        .replace('.', ',');
    },
    getBtwPrice(price) {
      return ( parseFloat(price) * 1.21)
        .toFixed(2)
        .replace('.', ',');
    }
  }
}
</script>

<style scoped lang="scss">
.product-card {
  background-color: white;
  width: 100%;
  height: auto;
  max-height: 350px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  transition: all ease-out 0.2s;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: inherit;
  overflow: hidden;

  &:hover {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);

    .card-button {
      .btn-green {
        background-position: left;
      }
    }
  }

  .card-image {
    margin-top: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: all ease-out 0.2s;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 5%;
    max-height: 217px;
    width: 100%;
    height: 100%;
    max-width: 217px;
    position: relative;
    overflow: hidden;
    margin-bottom: 6px;

    img {
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;

      @media only screen and (min-width: 900px) {
        margin-top: auto;
        padding: 0 8px;
      }

      @media only screen and (max-width: 576px) {
        margin-top: auto;
      }
    }

    @media only screen and (max-width: 375px) {
      padding: 0 15px;
    }
  }
}

.product-card-header {
  align-self: flex-start;
  padding: 10px;

  @media (max-width: 375px) {
    padding: 5px;
  }

  .label {
    font-family: var(--configurator-font-heading);
    color: var(--configurator-primary);
    font-weight: var(--configurator-font-weight-bold);
    font-size: 14px;
  }

  .article-number {
    font-size: 11px;
    font-weight: $font-weight-regular;
    align-self: flex-start;
  }
}

.delivery-time {
  align-self: flex-start;
  background: $blue-100;
  width: 100%;
  font-size: 11px;
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 10px;

  @media (max-width: 375px) {
    padding: 6px;
  }

  .icon {
    position: relative;
    top: -1px;
  }

  strong {
    font-family: var(--configurator-font-heading)
  }
}

.price-btn-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 7px;
  gap: 40px;
  background: $gray-50;

  &.has-delivery-time {
    background: white;
  }

  .btn {
    width: 100%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.prices {
  margin-left: 2px;
}

.previous-price {
  text-decoration: line-through;
  font-size: 12px;
  font-family: var(--configurator-font-heading);
}

.current-price {
  color: var(--configurator-primary);
  font-family: var(--configurator-font-heading);
  font-weight: var(--configurator-font-weight-bold);
  font-size: 20px;
  white-space: nowrap;

  &.with-tax {
    font-size: 12px;
    font-weight: $font-weight-regular;
  }

  .quantity, .tax {
    color: $black;
    font-size: 11px;
    font-weight: $font-weight-regular;
    font-family: $font;
  }
}

</style>
